const actions = {
  EDIT_PROFILE_TOGGLE: "EDIT_PROFILE_TOGGLE",
  EDIT_PROFILE: "EDIT_PROFILE",
};

export default actions;
